import { tableListCamera } from 'View/report-attendance-operator-detail/section/table/const/tableListCamera';
import { tableListRest } from 'View/report-attendance-operator-detail/section/table/const/tableListRest';

export const getTableList = (selectedTab, onOpenPreview) => {
  switch (selectedTab) {
    case 'restViolation':
      return tableListRest;
    case 'cameraViolation':
      return tableListCamera(onOpenPreview);
    default:
      return [];
  }
};
